export const GET_PETITIONS_REQUEST = 'GET_ASSIGN_PETITIONS_REQUEST';
export const GET_PETITIONS_SUCCESS = 'GET_ASSIGN_PETITIONS_SUCCESS';
export const GET_PETITIONS_FAILED = 'GET_ASSIGN_PETITIONS_FAILED';

export const PRINT_PETITIONS_REQUEST = 'PRINT_PETITIONS_REQUEST';
export const PRINT_PETITIONS_SUCCESS = 'PRINT_PETITIONS_SUCCESS';
export const PRINT_PETITIONS_FAILED = 'PRINT_PETITIONS_FAILED';

export const ASSIGN_LABELS_REQUEST = 'ASSIGN_LABELS_REQUEST';
export const ASSIGN_LABELS_SUCCESS = 'ASSIGN_LABELS_SUCCESS';
export const ASSIGN_LABELS_FAILED = 'ASSIGN_LABELS_FAILED';

export const TOGGLE_ALL_ROWS = 'TOGGLE_ALL_ROWS';
export const TOGGLE_ROWS_BULK = 'TOGGLE_ROWS_BULK';
export const SET_SELECTED_PETITION = 'SET_ASSIGN_SELECTED_PETITION';

export const FORCE_FETCH = 'FORCE_FETCH';
export const UPDATE_PETITION_PHOTO = 'UPDATE_PETITION_PHOTO';
export const COVER_PAGE_ONLY_TOGGLE = 'COVER_PAGE_ONLY_TOGGLE';
